<template>
    <el-container class="h-full">
        <div class="h-screen bg-main my-top clearfix relative w-full overflow-hidden">

            <!-- Wave-->
            <div class="orc-wave"></div>

            <div class="w-full h-full p-0 absolute flex justify-center">
                <div class="self-center activate-dialog">
                    <div class="text-center w-full mb-4"><h1 class="text-white text-3xl font-thin">Account activeren</h1></div>
                    <el-card shadow="always" class="orc-wave-blue mb-5">
                        <div class="mx-4 mt-1 mb-10">
                            <div class="mb-6">
                                <h1 class="text-xl"><i class="el-icon-set-up mr-2"></i>Wachtwoord instellen</h1>
                            </div>

                            <!-- alert -->
                            <el-alert v-if="pwProcessed" title="Wachtwoord ingesteld!" description="Het nieuwe wachtwoord kan nu gebruikt worden om in te loggen." type="success" effect="dark" :closable="false" class="mb-4"></el-alert>
                            <el-alert v-if="pwMatchError" title="Wachtwoorden komen niet overeen!" type="error" effect="dark" :closable="false" show-icon class="mb-4"></el-alert>
                            <el-alert v-if="error" title="Kan wachtwoord niet aanpassen!" type="error" effect="dark" :closable="false" show-icon class="mb-4"></el-alert>
                            <el-alert v-if="pwError" title="Ongeldig wachtwoord" description="Wachtwoord moet uit minstens 8 karakters bestaan en minstens één cijfer en hoofdletter bevatten." type="error" effect="dark" :closable="false" class="mb-4"></el-alert>

                            <!-- form -->
                            <el-form :model="form" ref="form" :rules="rules">
                                <el-form-item prop="password">
                                    <el-input placeholder="Wachtwoord" v-model="form.password" prefix-icon="el-icon-key" show-password></el-input>
                                </el-form-item>
                                <el-form-item prop="confirmPassword">
                                    <el-input placeholder="Wachtwoord bevestigen" v-model="form.confirmPassword" prefix-icon="el-icon-key" show-password></el-input>
                                </el-form-item>
                            </el-form>
                        </div>

                        <div class="flex justify-center m-4">
                            <el-button type="primary" :loading="loading" @click="submitForm('form')" :disabled="pwProcessed || error">Activeren<i class="ml-2 el-icon-right"></i></el-button>
                        </div>
                    </el-card>
                    <div class="flex float-right">
                        <a class="social-badge mr-2" href="https://www.instagram.com/orcabilzen/">
                            <img src="../assets/instagram-brands.svg" width="20" height="20" class="text-white"/>
                        </a>

                        <a class="social-badge" href="https://www.facebook.com/OrcaBilzen/">
                            <img src="../assets/facebook-f-brands.svg" width="15" height="15"/>
                        </a>
                    </div>
                </div>
            </div>

            <div class="w-full absolute">
                <header class="orc-vert-limit-header">
                    <div class="flex justify-between mt-4">
                        <!-- Logo -->
                        <router-link :to="{ path: 'home'}">
                            <div class="logo orc-strong">
                                ORCA
                            </div>
                        </router-link>
                    </div>
                </header>
            </div>
        </div>
    </el-container>
</template>

<script>
    export default {
        name: "Activate",
        data() {
            return {
                form: {
                    password: "",
                    confirmPassword: ""
                },
                dialogVisible: true,
                loading: false,
                error: false,
                pwMatchError: false,
                pwError: false,
                pwProcessed: false,
                id: null,
                token: null,

                // Rules
                rules: {
                    password: [
                        {required: true, message: 'Vul een wachtwoord in.', trigger: 'blur'}
                    ],
                    confirmPassword: [
                        {required: true, message: 'Bevestig het wachtwoord.', trigger: 'blur'}
                    ],
                }
            }
        },
        created () {
            this.id = this.$route.query.user
            this.token = this.$route.query.token
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.pwError = false
                        this.pwMatchError = false
                        if (this.form.password !== this.form.confirmPassword) {
                            this.pwMatchError = true
                            return false
                        }
                        if(!this.passwordValidator(this.form.password)) {
                            this.pwError = true
                            return false
                        }
                        this.loading = true
                        this.resetPassword()
                    }
                });
            },
            passwordValidator(password) {
                return /[a-z]/.test(password) && /[0-9]/.test(password) && /[A-Z]/.test(password);
            },
            resetPassword() {
                this.$http.post('users/reset/' + this.id, {
                    'token': this.token,
                    'password': this.form.password
                })
               .then((response) => {
                    this.pwProcessed = true
                    this.loading = false
                })
                .catch((error) => {
                    this.error = true
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
    .activate-dialog {
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Activate.vue